import { Step } from 'react-joyride';

// First Login Tour - Comprehensive introduction for new users
export const firstLoginTourSteps: Step[] = [
  {
    target: 'body',
    content: (
      <div>
        <h3>Welcome to Sawport Dashboard! 🎉</h3>
        <p>
          We're excited to have you here! Let's take a quick 2-minute tour to help you get started
          with the platform. You'll learn the essentials to start managing customer conversations
          effectively.
        </p>
        <p style={{ fontSize: '13px', color: '#828282', marginTop: '12px' }}>
          You can skip this tour anytime and access it later from the help menu.
        </p>
      </div>
    ),
    placement: 'center',
    disableBeacon: true,
    styles: {
      options: {
        width: 500
      }
    }
  },
  {
    target: '[data-tour="sidebar"]',
    content: (
      <div>
        <h4>Navigation Sidebar</h4>
        <p>
          This is your main navigation menu. All features and sections are accessible from here.
          Click any item to navigate to that section.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="dashboard-welcome"]',
    content: (
      <div>
        <h4>Your Dashboard</h4>
        <p>
          This is your home base - a real-time overview of key metrics, customer satisfaction
          scores, and team performance.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="sidebar-conversations"]',
    content: (
      <div>
        <h4>Conversations</h4>
        <p>
          Your main workspace for chatting with customers. Access live conversations and manage your
          customer queue here.
        </p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="sidebar-records"]',
    content: (
      <div>
        <h4>Chat Records</h4>
        <p>View historical conversations and search through past customer interactions.</p>
      </div>
    ),
    placement: 'right'
  },
  {
    target: '[data-tour="header-notifications"]',
    content: (
      <div>
        <h4>Notifications</h4>
        <p>
          Stay updated with important alerts, broadcasts, and system notifications. Click the bell
          icon to view them.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="header-profile"]',
    content: (
      <div>
        <h4>Your Profile</h4>
        <p>
          Access your profile settings, preferences, and logout option from here. You can also
          update your personal information.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="header-help"]',
    content: (
      <div>
        <h4>Help & Support</h4>
        <p>
          Need assistance? Click here to access the help center, documentation, or restart this tour
          anytime.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: 'body',
    content: (
      <div>
        <h3>You're All Set! 🚀</h3>
        <p>
          You've completed the basic tour. Feel free to explore the dashboard at your own pace. Each
          section has its own quick tour available when you visit it for the first time.
        </p>
        <p style={{ fontSize: '13px', color: '#828282', marginTop: '12px' }}>
          <strong>Pro tip:</strong> Look for the "?" icon in each section to access context-specific
          help.
        </p>
      </div>
    ),
    placement: 'center',
    styles: {
      options: {
        width: 480
      }
    }
  }
];
